import axios from 'axios';

let isRedirectingToLogin = false;

const axiosServices = axios.create({
  baseURL: import.meta.env.VITE_APP_API_URL
});

axiosServices.interceptors.request.use(
  (config) => {
    const serviceToken = localStorage.getItem('serviceToken');
    if (serviceToken) {
      config.headers['Authorization'] = `Bearer ${serviceToken}`;
    }

    // Add current frontend URL to all requests for logging
    config.headers['X-Frontend-Url'] = window.location.href;

    return config;
  },
  (error) => Promise.reject(error)
);

axiosServices.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response?.status === 401 &&
      !isRedirectingToLogin &&
      !window.location.pathname.includes('/login')
    ) {
      isRedirectingToLogin = true;
      localStorage.removeItem('serviceToken');
      window.dispatchEvent(new Event('auth:logout'));
      window.location.pathname = '/login';
    }

    return Promise.reject((error.response && error.response.data) || 'Wrong Services');
  }
);

export default axiosServices;

export async function fetcher(args) {
  const [url, config] = Array.isArray(args) ? args : [args];
  const res = await axiosServices.get(url, { ...config });
  return res.data;
}
